import * as React from 'react';
import { Text, Stack } from '@doordash/design-language';
import { AdminPageEmptyStateContainer, AdminPageEmptyStateLineBreak, } from './admin_page_empty_state_styles';
export var AdminPageEmptyState = function (_a) {
    var icon = _a.icon, title = _a.title, subtitle = _a.subtitle;
    return (React.createElement(AdminPageEmptyStateContainer, null,
        React.createElement(Stack, null,
            " ",
            icon,
            " "),
        React.createElement(AdminPageEmptyStateLineBreak, null),
        React.createElement(Stack, { size: Stack.Sizes.XxxSmall },
            React.createElement(Text, { color: Text.Colors.TextSecondary }, title)),
        React.createElement(AdminPageEmptyStateLineBreak, null),
        React.createElement(Stack, null,
            React.createElement(Text, { color: Text.Colors.TextSecondary }, subtitle))));
};
export default AdminPageEmptyState;
